const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

let headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to validate domain
const VerifyDomainAPI = async (
    token:string,
    websiteId: string
): Promise<any> => {
    let url = `${baseURL}/verify-domain`;

    const Formdata = new FormData();
    Formdata.append("key_token", websiteId);

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: Formdata
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export { VerifyDomainAPI }